import { useParams, useNavigate } from 'react-router-dom'
import { ArrowLeft, Phone, MapPin, Calendar, User } from 'lucide-react'
import { Button, Card, Badge } from '@/components/ui'
import { INQUIRY_STATUS_MAP, PRIORITY_MAP } from '@/constants'

const InquiryDetailPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  // Mock data
  const inquiry = {
    id,
    inquiryId: 'INQ240522001',
    customerName: 'Rahul Sharma',
    customerPhone: '9876543210',
    customerEmail: 'rahul@email.com',
    address: { 
      street: '123, ABC Society, Andheri East', 
      city: 'Mumbai', 
      state: 'Maharashtra', 
      pincode: '400069',
      landmark: 'Near Metro Station'
    },
    status: 'new',
    priority: 'high',
    source: 'walk_in',
    planInterest: 'Bharat Fiber Plus 200 Mbps',
    notes: 'Customer interested in high-speed plan for work from home',
    createdAt: new Date().toISOString(),
    preferredDate: '2024-05-25'
  }

  const handleAssign = () => {
    // Assign to engineer
  }

  return (
    <div className="p-4 space-y-4">
      {/* Header */}
      <div className="flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 hover:bg-gray-100 rounded-lg">
          <ArrowLeft size={24} />
        </button>
        <div>
          <p className="text-sm text-gray-500">{inquiry.inquiryId}</p>
          <h1 className="text-lg font-semibold">Inquiry Details</h1>
        </div>
      </div>

      {/* Status Card */}
      <div className="bg-gradient-to-r from-bsnl-primary to-bsnl-secondary rounded-xl p-4 text-white">
        <div className="flex items-center justify-between">
          <Badge variant="warning" className="bg-white/20 text-white border-0">
            {INQUIRY_STATUS_MAP[inquiry.status]?.label}
          </Badge>
          <Badge variant="danger" className="bg-white/20 text-white border-0">
            {PRIORITY_MAP[inquiry.priority]?.label} Priority
          </Badge>
        </div>
        <p className="text-2xl font-bold mt-3">{inquiry.customerName}</p>
        <p className="text-blue-200">Interested in {inquiry.planInterest}</p>
      </div>

      {/* Customer Info */}
      <Card>
        <h3 className="font-semibold text-gray-900 mb-4">Customer Information</h3>
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
              <User size={18} className="text-blue-600" />
            </div>
            <div>
              <p className="font-medium">{inquiry.customerName}</p>
              <p className="text-sm text-gray-500">{inquiry.customerPhone}</p>
            </div>
            <a href={`tel:${inquiry.customerPhone}`} className="ml-auto p-2 bg-green-100 rounded-full">
              <Phone size={18} className="text-green-600" />
            </a>
          </div>

          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mt-1">
              <MapPin size={18} className="text-orange-600" />
            </div>
            <div>
              <p className="font-medium">Installation Address</p>
              <p className="text-sm text-gray-600">
                {inquiry.address.street}, {inquiry.address.city} - {inquiry.address.pincode}
              </p>
              {inquiry.address.landmark && (
                <p className="text-sm text-gray-500">Landmark: {inquiry.address.landmark}</p>
              )}
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
              <Calendar size={18} className="text-purple-600" />
            </div>
            <div>
              <p className="font-medium">Preferred Date</p>
              <p className="text-sm text-gray-600">{inquiry.preferredDate || 'Not specified'}</p>
            </div>
          </div>
        </div>
      </Card>

      {/* Notes */}
      <Card>
        <h3 className="font-semibold text-gray-900 mb-2">Notes</h3>
        <p className="text-gray-600 text-sm">{inquiry.notes || 'No notes added'}</p>
      </Card>

      {/* Actions */}
      <div className="fixed bottom-20 left-4 right-4 max-w-md mx-auto">
        <Button onClick={handleAssign} fullWidth size="lg">
          Assign Engineer
        </Button>
      </div>
    </div>
  )
}

export default InquiryDetailPage
